export { AreaInfoBox } from './AreaInfoBox';
